<template>
  <div>
    <div class="title">可将图片另存，分享给好友</div>
    <div class="img">
      <div class="item" v-for="item of BannerList" :key="item.id">
        <img :src="item.wap_poster" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getSpreadImg, getUserPoster } from "@api/user";
export default {
  name: "BusinessCard",
  data() {
    return {
      BannerList: []
    };
  },
  created() {
    this.getIndex();
  },
  methods: {
    getBannerList() {
      getSpreadImg().then(res => {
        this.BannerList = res.data;
      });
    },
    getIndex: function() {
      let that = this;
      console.log(that.$route.query);
      if (JSON.stringify(that.$route.query) !== "{}") {
        console.log("yes");
        getUserPoster({ uid: that.$route.query.uid, type: 2 }).then(
          res => {
            that.BannerList = res.data;
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      } else {
        getSpreadImg().then(
          res => {
            that.BannerList = res.data;
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
      }

      // getUserPoster({ uid, type: 2 }).then(res => {
      //   console.log(res);
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  text-align center
  font-size 16px
  font-weight 700
  color #666
  margin-bottom 20px
.img
  display flex
  justify-content space-between
  .item
    width 30%
    height 100%
    img
      width 100%
</style>
